import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  user: {},
  displayName: ''
}

const mutations = {
  updateUser (state, { user }) {
    Vue.set(state, 'user', user)
    Vue.set(state, 'displayName', user.displayName)
  }
}
const actions = {
}

const getters = {
  user: state => state.user,
  displayName: state => state.displayName
}
const store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters
})

export default store